import { useCallback, useEffect, useState } from 'react'
import { useStore } from 'zens-store'

export interface FeatureSubscription {
  feature: string
  name: string
  plan_code: string | null
  plan_name: string | null
  available_plans: { code: string; name: string }[]
}

export interface CompanySubscriptionsResponse {
  company_id: number
  subscriptions: FeatureSubscription[]
}

export const useCompanySubscriptions = (companyId: number, enabled = true) => {
  const { api } = useStore()
  const [attempt, setAttempt] = useState(0)
  const [state, setState] = useState<{ companyId: number; data?: CompanySubscriptionsResponse; error?: boolean }>()
  const reload = useCallback(() => setAttempt((value) => value + 1), [])

  useEffect(() => {
    let active = true
    setState(undefined)
    if (enabled) {
      Promise.resolve(api.get<CompanySubscriptionsResponse>(`companies/${companyId}/subscriptions`))
        .then((data) => {
          if (data?.company_id !== companyId || !Array.isArray(data.subscriptions))
            throw new Error('Invalid subscriptions')
          if (active) setState({ companyId, data })
        })
        .catch(() => {
          if (active) setState({ companyId, error: true })
        })
    }
    return () => {
      active = false
    }
  }, [api, companyId, enabled, attempt])

  const current = enabled && state?.companyId === companyId ? state : undefined
  return { data: current?.data, error: !!current?.error, loading: enabled && !current, reload }
}
